import React, { PropTypes } from 'react';
import { inject, observer } from "mobx-react";
import { observable, action, toJS } from 'mobx';
import Form from './Form';
import FormMultiSelectInput from "./FormMultiSelectInput";
import { DateInput, SwitchInput, FormBody, SelectInput } from './Form';

@inject('stationStore', 'locationStore', 'locationTypeStore', 'stationStore', 'mapStore')
@observer
class DataFilter extends React.Component {


  @observable filters = {
    station_id: "",
    filter_by_location: false,
    location_id: 0,
    location_type_id: 0,
  }
  @observable multiStationOptions = [];
  @observable selectedStationIds = [];
  @action onChangeFilters = (e, key) => {
    this.filters[key] = e.target.value;
    if (key === 'location_type_id') this.filters.location_id = 0;
    this.locationFilter()
  }

  @action onChangeSelectedStations = items => {
    this.selectedStations = items;
  }

  componentWillMount() {
    const { mapStore, stationStore } = this.props;
    if (!mapStore.stations.length && !mapStore.loadingMarkers) mapStore.fetchMapMarkers();
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
  }


  componentDidMount() {
    const { locationStore, locationTypeStore } = this.props;
    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();
    this.populateOptions();
  }

  locationFilter() {
    const { stationStore, locationStore } = this.props;


    if (this.filters.location_type_id === 0 || this.filters.location_id === 0) {
      const allStationIds = stationStore.items.map((item) => item.id);
      this.props.onSelectedStationIdsChange(allStationIds);
      return allStationIds;
    }

    const item1 = stationStore.items.filter((item) => {
      return locationStore.isPartOf(item.location_id, this.filters.location_id);
    });

    const selectedStationIds = item1.map((item) => item.id);
    this.props.onSelectedStationIdsChange(selectedStationIds);
    return selectedStationIds;
  }

  populateOptions = () => {
    const { stationStore } = this.props;
    if (stationStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300);
    } else {
      this.multiStationOptions = stationStore.items.map((item) => ({
        id: item.id,
        name: item.name,
        label: item.name,
        value: true,
        tags: item.tags,
      }));
      this.onChangeSelectedStations(
        stationStore.items.map((item) => +item.id)
      );
      this.selectedStationIds = this.multiStationOptions.map((item) => +item.id)
      this.props.onSelectedStationIdsChange(this.selectedStationIds);
    }
  };

  onStationSelect = (item) => {
    item.value = !item.value;

    const selectedStationIds = this.getSelectedStationIds();
    this.props.onSelectedStationIdsChange(selectedStationIds);
  };

  optionsChangeAll = options => {
    this.multiStationOptions = options;
    const selectedStationIds = this.getSelectedStationIds();
    this.props.onSelectedStationIdsChange(selectedStationIds);
  }

  getSelectedStationIds() {
    return this.multiStationOptions
      .filter((item) => !!item.value)
      .map((item) => +item.id);
  }

  resetFormValues = () => {
    this.filters.station_id = "";
    this.filters.location_id = 0;
    this.filters.location_type_id = 0;

    this.multiStationOptions.forEach((item) => {
      item.value = true;
    });

    this.selectedStationIds = this.multiStationOptions.map((item) => +item.id);
    this.props.onSelectedStationIdsChange(this.selectedStationIds);
  };


  toggleFilterByLocation = () => {
    this.filters.filter_by_location = !this.filters.filter_by_location;
    this.resetFormValues();
  };

  _renderLocationFilterIinputs = () => {
    const { locationStore, locationTypeStore } = this.props;
    return (
      <div>
        <SelectInput label="Location Type" value={this.filters.location_type_id} options={[{ id: 0, name: "All" }, ...locationTypeStore.items]}
          isLoading={locationTypeStore.isLoading} onChange={(e) => this.onChangeFilters(e, "location_type_id")} fields={{ label: "name", value: "id" }} />
        {this.filters.location_type_id !== 0 && (
          <SelectInput label="Location" value={this.filters.location_id}
            options={[{ id: 0, name: "All" }, ...locationStore.items.filter((item) => item.type_id === this.filters.location_type_id),]}
            isLoading={locationStore.isLoading} onChange={(e) => this.onChangeFilters(e, "location_id")} fields={{ label: "name", value: "id" }} />
        )}
      </div>
    );
  };


  render() {
    const { stationStore } = this.props;
    return (
      <div>
        <Form>
          <FormBody>
            <SwitchInput label="Filter By Location" value={this.filters.filter_by_location} onChange={() => { this.toggleFilterByLocation(); }} />
            {!this.filters.filter_by_location && (
              <FormMultiSelectInput id="station-multi-select" label="Stations" options={this.multiStationOptions} optionClicked={this.onStationSelect} optionsChangeAll={this.optionsChangeAll} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />
            )}
            {this.filters.filter_by_location && this._renderLocationFilterIinputs()}
          </FormBody>
        </Form>
      </div>
    )
  }
}


export default DataFilter



// WEBPACK FOOTER //
// ./src/components/StationFilter.js